"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_admin_1 = require("react-admin");
var Teams_module_css_1 = __importDefault(require("../Teams/Teams.module.css"));
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var react_i18next_1 = require("react-i18next");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var react_2 = require("react");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var styles_1 = require("@mui/material/styles");
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var material_1 = require("@mui/material");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var pro_duotone_svg_icons_1 = require("@fortawesome/pro-duotone-svg-icons");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var material_2 = require("@mui/material");
var avatarStyles = [
    { backgroundColor: "#165152", color: "#E2EAC2" },
    { backgroundColor: "#E2EAC2", color: "#165152" },
    { backgroundColor: "#8DB900", color: "#E2EAC2" },
    { backgroundColor: "#165152", color: "#CFDBB7" },
];
var UserAvatar = function (_a) {
    var imageUrl = _a.imageUrl, name = _a.name, _b = _a.styleIndex, styleIndex = _b === void 0 ? 0 : _b;
    var renderAvatarContent = function () {
        if (imageUrl) {
            return react_1.default.createElement("img", { src: imageUrl, alt: "User Avatar", className: Teams_module_css_1.default.user_avatar_image });
        }
        else {
            var initial = name.charAt(0).toUpperCase();
            var style = avatarStyles[styleIndex % avatarStyles.length];
            return (react_1.default.createElement("div", { className: "".concat(Teams_module_css_1.default.user_avatar_initial, " ns-font-family-bold"), style: style },
                react_1.default.createElement("span", { className: Teams_module_css_1.default.user_avatar_initial_span }, initial)));
        }
    };
    return (react_1.default.createElement(Tooltip_1.default, { title: react_1.default.createElement("pre", { style: { margin: 0, padding: 0, fontFamily: "Geomanist" } }, name), placement: "top", arrow: true, PopperProps: {
            sx: {
                ".MuiTooltip-arrow": {
                    color: "var(--secondary-color)",
                },
                ".MuiTooltip-tooltip": {
                    backgroundColor: "var(--secondary-color)",
                    color: "var(--info-color)",
                    borderRadius: "7px",
                    padding: "12px"
                },
            },
        } },
        react_1.default.createElement("div", { className: Teams_module_css_1.default.user_avatar_container, "data-cy": "userAvatar" }, renderAvatarContent())));
};
var UserAvatarGroup = function (_a) {
    var users = _a.users;
    var maxDisplay = 4;
    var additionalMembers = users.length > maxDisplay ? users.length - maxDisplay : 0;
    var displayedUsers = users.slice(0, maxDisplay);
    var additionalUserNames = users.slice(maxDisplay).map(function (user) { return user.name; }).join("\n");
    return (react_1.default.createElement("div", { className: Teams_module_css_1.default.user_avatar_group_container },
        additionalMembers > 0 && (react_1.default.createElement(Tooltip_1.default, { title: react_1.default.createElement("pre", { style: { margin: 0, padding: 0, fontFamily: "Geomanist" } }, additionalUserNames), placement: "top", arrow: true, PopperProps: {
                sx: {
                    ".MuiTooltip-arrow": {
                        color: "var(--secondary-color)",
                    },
                    ".MuiTooltip-tooltip": {
                        backgroundColor: "var(--secondary-color)",
                        color: "var(--info-color)",
                        borderRadius: "7px",
                        padding: "12px"
                    },
                },
            } },
            react_1.default.createElement("div", { className: Teams_module_css_1.default.additional_members_tooltip_container },
                react_1.default.createElement("span", { className: " ns-font-family-bold", style: { position: "relative", top: "2px" } },
                    "+",
                    additionalMembers),
                react_1.default.createElement("div", { className: Teams_module_css_1.default.additional_members_tooltip_content }, additionalUserNames)))),
        displayedUsers.map(function (user, index) { return (react_1.default.createElement(UserAvatar, { key: user.id, imageUrl: user.profile_photo_path, name: user.name, styleIndex: index })); })));
};
var RowActionMenu = function (_a) {
    var handleRowClick = _a.handleRowClick;
    var _b = (0, react_2.useState)(null), menuAnchorElement = _b[0], setMenuAnchorElement = _b[1];
    var menuOpen = Boolean(menuAnchorElement);
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var refresh = (0, react_admin_1.useRefresh)();
    var record = (0, react_admin_1.useRecordContext)();
    var logger = q_play_core_1.logManager.getLogger();
    var handleClick = function (e) {
        setMenuAnchorElement(e.currentTarget);
        e.stopPropagation();
    };
    var handleClose = function (e) {
        setMenuAnchorElement(null);
        e.stopPropagation();
    };
    var deleteTeam = function (teamId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.deleteQteam(teamId)];
                case 1:
                    _a.sent();
                    refresh();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Failed to delete team:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var duplicateTeam = function (teamId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(record && record.id)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.duplicateQteam(teamId)];
                case 2:
                    _a.sent();
                    refresh();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    logger.error("Failed to duplicate team:", error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.IconButton, { "aria-label": "more", id: "long-button", "aria-controls": menuOpen ? "long-menu" : undefined, "aria-expanded": menuOpen ? "true" : undefined, "aria-haspopup": "true", onClick: function (e) {
                handleClick(e);
            }, className: Teams_module_css_1.default.icon_button, "data-cy": "teamListRowMenuButton" },
            react_1.default.createElement("span", { className: Teams_module_css_1.default.custom_icon_container }, menuOpen ?
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTimes, className: Teams_module_css_1.default.close_menu_icon }) :
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faCircleEllipsis, className: Teams_module_css_1.default.open_menu_icon }))),
        react_1.default.createElement(material_1.Menu, { id: "teams-dropdown-menu", MenuListProps: {
                "aria-labelledby": "dropdown-button",
            }, anchorEl: menuAnchorElement, anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "left",
            }, open: menuOpen, onClose: handleClose, sx: {
                marginLeft: "-75px",
                width: "130px",
                borderRadius: "7px",
            } },
            react_1.default.createElement(material_1.MenuItem, { onClick: function (e) { handleRowClick(record); handleClose(e); }, className: "ns-font-family", style: { color: "var(--info-color)", fontSize: "12px" } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, color: "var(--primary-color)", size: "1x", style: {
                        marginRight: "5px"
                    } }),
                t("Edit")),
            react_1.default.createElement(material_1.MenuItem, { onClick: function (e) {
                    duplicateTeam(Number(record.id));
                    handleClose(e);
                }, className: "ns-font-family", style: { color: "var(--info-color)", fontSize: "12px" }, "data-cy": "duplicateTeamButton" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, color: "var(--primary-color)", size: "1x", style: { marginRight: "5px" } }),
                t("Duplicate")),
            !record.locked && (react_1.default.createElement(material_1.MenuItem, { onClick: function (e) {
                    deleteTeam(Number(record.id));
                    handleClose(e);
                }, className: "ns-font-family", style: {
                    color: "var(--info-color)",
                    fontSize: "12px",
                    display: "block"
                }, "data-cy": "deleteTeamButton" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, color: "var(--primary-color)", size: "1x", style: {
                        marginRight: "5px"
                    } }),
                t("Delete"))))));
};
var TeamsList = function (_a) {
    var handleRowClick = _a.handleRowClick, props = __rest(_a, ["handleRowClick"]);
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    // const teamsFilters = [<SearchInput source="name" alwaysOn key="queryFilter" />];
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaTeamsFilterInputTheme },
            react_1.default.createElement(react_admin_1.ListBase, __assign({}, props),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTeamsTheme },
                        react_1.default.createElement(react_admin_1.Datagrid, { "data-cy": "teamListTable", hover: false, sx: RAStyles_1.RaTeamsDataGridSx, bulkActionButtons: false, rowClick: function (id, basePath, record) {
                                handleRowClick(record);
                                return false;
                            } },
                            react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name"), "data-cy": "teamListNameRow" }),
                            react_1.default.createElement(react_admin_1.ArrayField, { source: "roles", label: t("Roles"), sortable: false },
                                react_1.default.createElement(react_admin_1.SingleFieldList, { linkType: false },
                                    react_1.default.createElement(react_admin_1.FunctionField, { render: function (record) { return (react_1.default.createElement(material_2.Chip, { label: t(record.display_name), sx: {
                                                borderRadius: "7px",
                                                color: "var(--info-color)",
                                                backgroundColor: "var(--secondary-color)",
                                                margin: "5px"
                                            } })); } }))),
                            react_1.default.createElement(react_admin_1.FunctionField, { label: t("Members"), render: function (record) { return (react_1.default.createElement(UserAvatarGroup, { users: record.users || [] })); } }),
                            react_1.default.createElement(react_admin_1.DateField, { showTime: false, label: t("Last edited"), source: "updated_at", textAlign: "center" }),
                            react_1.default.createElement(RowActionMenu, { handleRowClick: handleRowClick })))),
                react_1.default.createElement(Pagination_1.default, null)))));
};
exports.default = TeamsList;
